import { useReportMetricsContextV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import CostOfGoodsSoldReportTableV2 from 'src/tables/CostOfGoodsSoldReportTable/CostOfGoodsSoldReportTable';

import { ReportsPageLayout } from '../Reports/ReportsPageLayout';
import * as styles from './ReportsCostOfGoodsSoldPage.css';

export function ReportsCostOfGoodsSoldPage() {
  // All the child components treat tempReportConfig as the reportConfig
  // to get its latest state
  const {
    tempReportConfig: reportConfig,
    reportMetrics,
    reportSummary,
    reportValueTypes,
  } = useReportMetricsContextV2();

  return (
    <ReportsPageLayout
      reportConfig={reportConfig}
      reportTable={
        <CostOfGoodsSoldReportTableV2
          className={styles.table}
          metricsData={reportMetrics}
          summaryData={reportSummary}
          report={reportConfig}
          reportValueTypes={reportValueTypes}
        />
      }
    />
  );
}
